<template>
  <div>
    <div
      class="background-complementary-50 padding-0 flex flex-start gap-3 width--fit-content border border-complementary-50 border-radius-6 min-height-42"
      v-if="microphonePermissionState !== 'granted'"
    >
      <span class="color-complementary-400">
        <mdicon name="microphone-off" size="24" />
      </span>

      <span class="color-complementary-400 ml-2">{{
        $lang.recordMeeting
      }}</span>
    </div>

    <div
      @click="!isDisabled && state === 'stop' && handleOpenViewModal()"
      v-else
      class="`gap-12 height-42 border border-complementary-50 border-radius-6 padding-0`"
      :class="{
        'background-surface': !isDisabled,
        'background-complementary-50 color-surface cursor--not-allowed':
          isDisabled,
        'box-hover cursor--pointer': state === 'stop',
        'width-percent-100': checkScreenDevice(['tablet', 'mobile']),
        'width--fit-content': checkScreenDevice(['desktop']),
        'flex-between': checkScreenDevice(['tablet', 'mobile']),
        'flex-start': checkScreenDevice(['desktop']),
        'justify-content-center':
          checkScreenDevice(['tablet', 'mobile']) && state === 'stop',
      }"
    >
      <div
        class="flex gap-2 ml-2"
        v-if="state !== 'stop'"
        :class="{ 'background-complementary-50 color-surface': isDisabled }"
      >
        <span
          @click="handleResumeRecording"
          v-if="state === 'pausing'"
          class="font-size-16 icon-hover cursor-pointer"
        >
          <mdicon name="play" size="24" />
        </span>

        <span
          @click="handlePauseRecording"
          v-if="state === 'recording'"
          class="font-size-16 cursor-pointer icon-hover"
        >
          <mdicon name="pause" size="24" />
        </span>
        <span
          @click.stop="handleStopRecord"
          class="color-primary-600 icon-hover font-size-16 cursor-pointer"
        >
          <mdicon name="stop-circle" size="24" />
        </span>
      </div>
      <span
        v-if="state !== 'stop'"
        class="color-complementary-400 font-size-16 width-64"
      >
        {{ counter }}
      </span>
      <div v-if="state === 'stop'" class="flex-start">
        <span
          class="color-complementary-400"
          :class="{ 'icon-hover': !isDisabled, 'color-surface': isDisabled }"
        >
          <mdicon name="microphone-outline" size="20" />
        </span>
        <span
          class="color-complementary-400 margin-right-4 margin-left-10 width--max-content"
          :class="{ 'color-surface': isDisabled }"
        >
          {{ $lang.recordMeeting }}
        </span>
      </div>

      <div
        @click="handleOpenViewModal"
        v-if="state !== 'stop'"
        class="cursor-pointer height-percent-100 width-40 position-relative flex flex-column justify-content-end border border-left-0 border-top-0 border--0"
      >
        <span
          :style="{
            top: '50%',
            right: '50%',
            transform: 'translateX(50%) translateY(-50%)',
          }"
          class="position-absolute color-complementary-200 font-size-16"
        >
          <mdicon name="microphone-outline" size="24" />
        </span>

        <div
          :style="{
            height: `${
              avgVolume * 15 * 100 < 100 ? avgVolume * 2 * 100 : 100
            }%`,

            transition: 'height 0.1s',
          }"
          class="background-primary-100 width-percent-100"
        ></div>
      </div>
    </div>

    <Modal
      :show="isViewModal"
      :title="$lang.voiceRecord"
      :closeOnBackdrop="false"
      :hasClose="true"
      :hasFooter="false"
      contentClass="height--max-content overflow-y-auto"
      size="sm"
      @close="handleCloseViewModal"
    >
      <template #body>
        <div
          class="flex flex-column justify-content-center align-items-center mt-4 w-full"
        >
          <div
            @click="state == 'stop' && handleStartRecord()"
            ref="micWrapper"
            :class="`width-200 height-200 border-radius-100 background-primary position-relative margin-bottom-40 ${
              state == 'stop' && 'cursor--pointer'
            }`"
          >
            <span
              ref="firstSignal"
              class="position-absolute width-200 height-200 background-primary-50 border-radius-100"
            ></span>

            <span
              ref="secondSignal"
              class="position-absolute width-200 height-200 background-primary-100 border-radius-100"
            ></span>

            <span
              class="position-absolute width-200 height-200 background-primary border-radius-100 flex justify-content-center align-content-center flex-wrap color-surface"
            >
              <mdicon name="microphone-outline" size="80" />
            </span>
          </div>

          <div
            v-if="state !== 'stop'"
            class="flex-center height-50 width-percent-100"
          >
            <span
              v-for="(barItem, index) in bars"
              :style="{
                height: `${
                  (barItem + 0.02) * 650 < 50 ? (barItem + 0.02) * 200 : 50
                }px`,
                transition: 'height 0.3s',
              }"
              :key="index"
              :class="`width-4 
              } margin-right-4 background-primary border-radius-2`"
            />
          </div>

          <div
            class="flex-center height-50 width-percent-100"
            v-if="state === 'stop'"
          >
            <Dropdown
              :options="avilableAudioDevices"
              class="width-percent-80"
              name="device"
              id="device"
              :value="device"
              inputPlaceholder=""
              rowClass="margin-bottom-16"
              :hasRemoveIcon="false"
              @change="changeDvice"
            />
          </div>

          <p class="color-complementary-200 font-size-24 margin-top-20">
            {{ counter }}
          </p>

          <div
            v-if="state === 'stop'"
            class="flex align-items-center justify-content-center margin-top-20"
          >
            <Button
              contentClass="justify-content-center"
              variant="primary"
              :text="$lang.voiceRecord"
              :disabled="!device"
              class="width-200"
              @click="handleStartRecord"
            />
          </div>

          <div
            v-if="state !== 'stop'"
            class="flex align-items-center justify-content-center margin-top-20"
          >
            <Button
              variant="primary"
              :text="$lang.stopRecord"
              class="margin-left-16 width--max-content"
              @click="handleStopRecord"
            />
            <Button
              v-if="state === 'recording'"
              variant="outline-primary"
              :text="$lang.pause"
              rightIcon="pause"
              class="width--max-content"
              @click="handlePauseRecording"
            />
            <Button
              v-if="state === 'pausing'"
              variant="outline-primary"
              :text="$lang.resume"
              rightIcon="play"
              class="width--max-content"
              @click="handleResumeRecording"
            />
          </div>
          <span
            @click="handleCloseViewModal"
            class="color-primary margin-top-16 cursor-pointer"
            >{{ $lang.goMinimal }}</span
          >
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "../modal/Modal.vue";

import { Button, Dropdown } from "@/components/re-design/forms";
import { computed, onMounted, ref, watch } from "vue";
import { openDB } from "idb";
import NoSleep from "nosleep.js";
import { toastAlert, generateLang, checkScreenDevice } from "@/shared/utils";
import {
  generateRandomPassword,
  generateStoreGetters,
  storeDispatcher,
} from "@/shared/utils";
import dayjs from "dayjs";
import jalaliday from "jalaliday";

dayjs.extend(jalaliday);
dayjs.calendar("jalali");

export default {
  components: { Modal, Button, Dropdown },
  props: {
    uploadUrl: {
      type: String,
      default: null,
    },
    attachmentTypeId: {
      type: [Number, String],
      default: null,
    },
    attachmentTypeName: {
      type: String,
      default: null,
    },
    caption: {
      type: String,
      default: "",
    },
    successfullyMessage: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const noSleep = new NoSleep();
    function isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    }
    let dbPromise;
    async function get(key) {
      return (await dbPromise).get("keyval", key);
    }
    async function set(key, val) {
      return (await dbPromise).put("keyval", val, key);
    }

    const microphonePermissionState = ref("denied");
    const avilableAudioDevices = ref([]);
    const state = ref("stop");
    const savedAudio = ref([]);
    const progresswidth = ref(0);
    const mediaRecorder = ref(undefined);
    const personCode = ref("");
    const duration = ref(0);
    const canavas = ref(null);
    const bars = ref([]);
    const myMicSvg = ref(null);
    const micWrapper = ref(null);
    const firstSignal = ref(null);
    const secondSignal = ref(null);
    const isViewModal = ref(false);
    const device = ref(null);
    const avgVolume = ref(0);

    const handleCloseViewModal = () => {
      isViewModal.value = false;
    };

    const handleOpenViewModal = () => {
      isViewModal.value = true;
    };

    const changeDvice = (value) => {
      device.value = value;
    };

    watch(micWrapper, (value) => {
      if (value) {
        myMicSvg.value = value.lastChild.lastChild;
      }
    });

    const resetRecorder = () => {
      mediaRecorder.value = undefined;
      progresswidth.value = 0;
      startedTime.value = 0;
      differentTime.value = 0;
      pauseTime.value = 0;
    };
    const startedTime = ref(0);
    const differentTime = ref(0);
    const pauseTime = ref(0);

    const timerQueue = ref(null);
    const counter = ref("00:00:00");
    const resetTimer = () => {
      counter.value = "00:00:00";
      clearInterval(timerQueue.value);
    };

    const isIos = computed(() => {
      if (typeof window === `undefined` || typeof navigator === `undefined`)
        return false;

      return /iPhone|iPad|iPod/i.test(
        navigator.userAgent ||
          navigator.vendor ||
          (window.opera && opera.toString() === `[object Opera]`)
      );
    });
    const generatePrettyTime = (distance) => {
      // generate time to pretty timer format
      const HOURS = 1000 * 60 * 60 * 24;
      const MINUTES = 1000 * 60 * 60;
      const SECONDS = 1000 * 60;
      let hours = Math.floor((distance % HOURS) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % MINUTES) / (1000 * 60));
      let seconds = Math.floor((distance % SECONDS) / 1000);
      hours = hours >= 10 ? hours : `0${hours}`;
      minutes = minutes > 0 ? minutes : 0;
      minutes = minutes >= 10 ? minutes : `0${minutes}`;
      seconds = seconds >= 10 ? seconds : `0${seconds}`;
      return `${hours}:${minutes}:${seconds}`;
    };
    const timer = () => {
      let distance = 0;
      clearInterval(timerQueue.value);
      let currentTime = new Date().getTime();
      timerQueue.value = setInterval(() => {
        currentTime = currentTime + 1000;
        differentTime.value = currentTime - startedTime.value + pauseTime.value;
        distance = differentTime.value;
        counter.value = generatePrettyTime(distance);
        duration.value = distance;
      }, 1000);
    };

    let softVolume = 0;
    let softVolumeFirstSignal = 0;

    const animate = (mic) => {
      if (state.value === "recording") {
        const volume = mic.getVolume();
        avgVolume.value = volume;
        if (myMicSvg.value && firstSignal.value) {
          const samples = mic.getSamples();

          bars.value = samples;
          softVolume = softVolume * 0.9 + volume * 0.1;
          softVolumeFirstSignal = softVolume * 1.1 + volume * 0.3;
          myMicSvg.value.style.transform = `scale(${1 + softVolume}, ${
            1 + softVolume
          })`;
          firstSignal.value.style.transform = `scale(${
            1 + softVolumeFirstSignal
          }, ${1 + softVolumeFirstSignal})`;
          secondSignal.value.style.transform = `scale(${1 + softVolume}, ${
            1 + softVolume
          })`;
        }
      }
      requestAnimationFrame(() => animate(mic));
    };

    const microphoneAnalyser = (stream) => {
      const audioContext = new AudioContext();
      const microphone = audioContext.createMediaStreamSource(stream);
      const analyser = audioContext.createAnalyser();
      analyser.fftSize = 64;
      const bufferLength = analyser.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);
      microphone.connect(analyser);

      const getSamples = () => {
        analyser.getByteTimeDomainData(dataArray);
        const normSamples = [...dataArray].map((e) => e / 128 - 1);
        return normSamples;
      };

      const getVolume = () => {
        analyser.getByteTimeDomainData(dataArray);
        const normSamples = [...dataArray].map((e) => e / 128 - 1);
        let sum = 0;

        normSamples.forEach((e) => {
          sum += e * e;
        });

        let volume = Math.sqrt(sum / normSamples.length);
        return volume;
      };

      return {
        audioContext,
        microphone,
        analyser,
        bufferLength,
        dataArray,
        getSamples,
        getVolume,
      };
    };

    const handlePauseRecording = async () => {
      try {
        // set pause recorder
        await mediaRecorder.value.pause();

        // set pausing state
        state.value = "pausing";

        // cerate time queue
        clearInterval(timerQueue.value);
        pauseTime.value = differentTime.value;
      } catch (error) {
        // toastAlert(error.message, "error");
      }
    };

    const handleResumeRecording = async () => {
      try {
        // set resume recorder
        await mediaRecorder.value.resume();
        // set recording state
        state.value = "recording";
        // regenerate timer
        startedTime.value = new Date().getTime();
        timer();
      } catch (error) {
        // toastAlert(error.message, "error");
      }
    };

    const getAudioRef = (audioChunk) => {
      return URL.createObjectURL(
        new Blob(audioChunk, {
          type: "audio/ogg",
        })
      );
    };

    const sendAudio = function (url, next) {
      try {
        const _player = new Audio(url);

        _player.addEventListener(
          "durationchange",
          function () {
            if (this.duration != Infinity) {
              var duration = this.duration;
              _player.remove();
              next(duration);
            }
          },
          false
        );

        _player.load();
        _player.currentTime = 24 * 60 * 60;
        _player.volume = 0;
        _player.play();
      } catch (e) {
        //
      }
    };

    function formatBytes(bytes, decimals = 2) {
      if (!+bytes) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = [
        "بایت",
        "کیلوبایت",
        "مگابایت",
        "گیگابایت",
        "ترابایت",
        "PB",
        "EB",
        "ZB",
        "YB",
      ];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    }
    const calcDuration = (duration) => {
      let hours;
      let min;
      let seconds;
      if (duration > 3600) {
        hours = Math.floor(duration / 3600);
        min = Math.floor((duration % 3600) / 60);
        if (min) {
          return ` ${hours} ${generateLang(["hour"])} و ${min} ${generateLang([
            "minute",
          ])}`;
        } else {
          return `${hours} ${generateLang(["hour"])}`;
        }
      } else if (duration > 60) {
        min = Math.floor((duration % 3600) / 60);
        seconds = Math.floor((duration % 3600) % 60);
        if (seconds) {
          return `${min} ${generateLang([
            "minute",
          ])} و ${seconds} ${generateLang(["second"])}`;
        }
        return `${min} ${generateLang(["minute"])}`;
      } else {
        seconds = Math.floor(duration);
        return `${seconds} ${generateLang(["second"])}`;
      }
    };
    const handleStartRecord = async () => {
      noSleep.enable();
      if (device.value.id) {
        resetRecorder();
        state.value = "recording";
        startedTime.value = new Date().getTime();
        timer();
        const audio =
          device.value.id.length > 0 ? { deviceId: device.value.id } : true;

        const stream = await navigator.mediaDevices.getUserMedia({
          audio,
          video: false,
        });

        const mic = microphoneAnalyser(stream);
        animate(mic);

        const option = {
          audioBitsPerSecond: 32000, // Set the desired bitrate (e.g., 128 kbps)
        };
        const recordedChunks = [];

        mediaRecorder.value = new MediaRecorder(stream, option);

        mediaRecorder.value.addEventListener("dataavailable", function (e) {
          if (e.data.size > 0) {
            recordedChunks.push(e.data);
          }
        });

        mediaRecorder.value.addEventListener("stop", async function () {
          try {
            savedAudio.value = [...savedAudio.value, recordedChunks];
            const savedRecords = (await get(personCode.value)) || [];

            const now = new Date();
            const createdAt = dayjs(now).format("YYYY/MM/DD HH:mm");
            const expireTime = dayjs(now)
              .add(2, "w")
              .format("YYYY/MM/DD HH:mm");
            const src = getAudioRef(recordedChunks);

            if (isIos.value) {
              savedRecords.push({
                audio: recordedChunks,
                createdAt,
                expireTime,
                duration: calcDuration(duration.value),
                uploadUrl: props.uploadUrl,
                size: formatBytes(recordedChunks[0].size),
                id: generateRandomPassword(),
                attachmentTypeId: props.attachmentTypeId,
                attachmentTypeName: props.attachmentTypeName,
                caption: props.caption,
              });
              let savedRecordLength = savedRecords.length;
              storeDispatcher("savedAudioRecordLength", savedRecordLength);
              await set(personCode.value, savedRecords);
              resetTimer();
              stream.getTracks().forEach(function (track) {
                track.stop();
              });
            } else {
              sendAudio(src, async (duration) => {
                savedRecords.push({
                  audio: recordedChunks,
                  createdAt,
                  expireTime,
                  duration: calcDuration(duration),
                  uploadUrl: props.uploadUrl,
                  size: formatBytes(recordedChunks[0].size),
                  id: generateRandomPassword(),
                  attachmentTypeId: props.attachmentTypeId,
                  attachmentTypeName: props.attachmentTypeName,
                  caption: props.caption,
                });

                let savedRecordLength = savedRecords.length;

                storeDispatcher("savedAudioRecordLength", savedRecordLength);
                await set(personCode.value, savedRecords);
                resetTimer();
                stream.getTracks().forEach(function (track) {
                  track.stop();
                });
              });
            }
            toastAlert(generateLang(["savedAudioSuccess"]));
          } catch (e) {
            toastAlert(generateLang["recordErrorSave"]);
          }
        });

        document.addEventListener("visibilitychange", () => {
          //   document.visibilityState === "hidden" &&
          //   state.value === "recording" &&
          // isMobileDevice() &&
          //    handlePauseRecording();
        });

        mediaRecorder.value.start();
      }
    };
    const currentUserInfo = computed(() => generateStoreGetters(["userInfo"]));

    watch(counter, (value) => {
      value === "00:75:00" &&
        !handleStopRecord() &&
        toastAlert(generateLang("voiceLimit"));
    });

    const handleStopRecord = () => {
      state.value = "stop";
      handleCloseViewModal();
      if (mediaRecorder.value) mediaRecorder.value.stop();
      noSleep.disable();
    };

    // handle Permission and select device for recored

    const handlePemissionState = (state) => {
      microphonePermissionState.value = state;
      if (state === "granted") {
        getAvailableAudioDevices().then((devices) => {
          const createdDevices = devices.map(({ id, name: caption }, index) => {
            return {
              id,
              caption: caption ? caption : `microphone (default ${index + 1})`,
            };
          });

          avilableAudioDevices.value = createdDevices;
          device.value = createdDevices.find(
            (device) => device.id === "default"
          );
        });
      }
    };

    const getAvailableAudioDevices = () => {
      return new Promise((resolve) => {
        navigator.mediaDevices.enumerateDevices().then((devices) => {
          const availableDevices = devices
            .filter((d) => d.kind === "audioinput")
            .map((d) => {
              return { id: d.deviceId, name: d.label };
            });
          resolve(availableDevices);
        });
      });
    };

    watch([isViewModal, avilableAudioDevices], ([visible, devices]) => {
      if (visible) {
        const defaultDevices = devices.find(({ id }) => id == "default");
        if (defaultDevices) {
          device.value = defaultDevices;
        } else {
          const [firstElement] = devices;
          device.value = firstElement;
        }
      }
    });

    watch(currentUserInfo, async (value) => {
      personCode.value = value.person.code;
      const savedRecords = await get(personCode.value);
      !savedRecords && set(personCode.value, []);
      savedAudio.value = savedRecords;
    });
    onMounted(async () => {
      if (currentUserInfo.value) {
        personCode.value = currentUserInfo.value.person.code;
      }
      navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(
        (stream) => {
          // microphone available
          handlePemissionState("granted");

          stream.getTracks().forEach(function (track) {
            track.stop();
          });
        },
        (e) => {
          // microphone not available
          toastAlert(e);
          handlePemissionState("denied");
        }
      );

      dbPromise = openDB("keyval-store", 1, {
        upgrade(db) {
          db.createObjectStore("keyval");
        },
      });
    });

    return {
      microphonePermissionState,
      handlePauseRecording,
      handleResumeRecording,
      handleStartRecord,
      handleStopRecord,
      state,
      avilableAudioDevices,
      counter,
      handleCloseViewModal,
      isViewModal,
      myMicSvg,
      micWrapper,
      firstSignal,
      secondSignal,
      canavas,
      bars,
      handleOpenViewModal,
      changeDvice,
      device,
      avgVolume,
      checkScreenDevice,
    };
  },
};
</script>
